import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as types from 'misc/types';
import { getText } from 'misc/helpers';
import PopupButton from './PopupButton';

export const popup_icon_type = {
    none: 0,
    error: 1,
    success: 2,
    logo: 3,
    archive: 4,
    delete: 5,
    bankid: 6
};

class Popup extends Component {
    render = () => {
        const { popup } = this.props;

        let popupHeader = undefined;
        let popupText = undefined;

        // Generate buttons from submitted actions
        let popupButtons = undefined;

        if (popup.data) {
            if (popup.data.showBankIdMenu) {
                // Bank ID menu
                popupHeader = '';
                popupText = getText('Missing', 'Välj inloggningsmetod');

                // Bank id options
                popupButtons = (
                    <React.Fragment>
                        <button className="button-yellow button-big button-bankid" onClick={() => this.waitForBankId()}>
                            {getText('Missing', 'Mobilt BankID')}
                        </button>

                        <button className="button-yellow button-big button-bankid" onClick={() => this.openBankIdDesktop()}>
                            {getText('Missing', 'BankID på fil')}
                        </button>
                    </React.Fragment>
                );
            } else {
                popupHeader = popup.data.header;
                popupText = popup.data.text;

                // Other custom buttons

                // Default button if no buttons are set
                if (!popup.data.noButtons) {
                    popupButtons = (
                        <button className="button-yellow button-ok" onClick={() => this.closePopup()}>
                            {getText('_12_1_TextButtonOK', 'Ok')}
                        </button>
                    );
                }

                if (popup.data.buttons) {
                    // Add key to each array child because React wants it
                    let key = 0;
                    popup.data.buttons.forEach(function(button) {
                        button.key = key;
                        key++;
                    });

                    popupButtons = <React.Fragment>{popup.data.buttons.map(button => <PopupButton {...button} />)}</React.Fragment>;
                }
            }
        }

        return (
            <div className={this.showOrNot()}>
                {popup.data && (
                    <div className="popup">
                        {/* Icon or logo*/}
                        {!popup.data.showBankIdMenu && (
                            <React.Fragment>
                                {popup.data.icon === popup_icon_type.error && <img src="assets/images/popup/ico_error.svg" alt="" />}
                                {popup.data.icon === popup_icon_type.success && <img src="assets/images/popup/ico_success.svg" alt="" />}
                                {popup.data.icon === popup_icon_type.archive && <img src="assets/images/popup/ico_archive.svg" alt="" />}
                                {popup.data.icon === popup_icon_type.delete && <img src="assets/images/popup/ico_delete.svg" alt="" />}
                                {popup.data.icon === popup_icon_type.logo &&
                                    popup.data.logo_url && <img src={popup.data.logo_url} alt="" />}
                                {popup.data.icon === popup_icon_type.bankid && <img src="assets/images/popup/ico_bankid.svg" alt="" />}
                            </React.Fragment>
                        )}

                        {popup.data.icon === popup_icon_type.bankid && (
                            <p>
                                <img src="assets/images/loader_spinner.svg" className="animation-spin" alt="" />
                            </p>
                        )}

                        {/* Info */}
                        {popupHeader && <h1>{popupHeader}</h1>}

                        {popupText && <p>{popupText}</p>}

                        {/* Support info */}
                        {popup.data.mail && (
                            <p>
                                <a href={'mailto:' + popup.data.mail}>{popup.data.mail}</a>
                            </p>
                        )}

                        {popup.data.phone && (
                            <p>
                                <b>{popup.data.phone}</b>
                            </p>
                        )}

                        {/* Buttons */}
                        {popupButtons}

                        {popup.data.cancelAction && (
                            <p className="nomargin">
                                <a onClick={() => this.performAction(popup.data.cancelAction)}>{getText('_1_TextCancel', 'Avbryt')}</a>
                            </p>
                        )}
                    </div>
                )}
            </div>
        );
    };

    showOrNot() {
        const { popup } = this.props;
        if (popup.data && popup.data.show) {
            return 'bg-fade animation-show';
        }
        return 'bg-fade';
    }

    performAction(action) {
        const { dispatch } = this.props;
        dispatch(action);
        this.closePopup();
    }

    openBankIdDesktop() {
        // Open desktop app
        window.location.href = 'bankid:///?redirect=null';

        this.waitForBankId();
    }

    waitForBankId() {
        const { dispatch } = this.props;
        dispatch({ type: types.POPUP_HIDE_BANKID });
    }

    closePopup() {
        const { dispatch } = this.props;
        dispatch({ type: types.POPUP_HIDE });
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        popup: state.popup,
        popup_bankid: state.popup_bankid
    };
};

Popup = connect(mapStateToProps)(Popup);

export default Popup;



// WEBPACK FOOTER //
// ./src/components/shared/popup/Popup.js